'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _spauiUtils = require('@tencent/spaui-utils');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _info2 = require('./info');

var _info3 = _interopRequireDefault(_info2);

var _props2 = require('./utils/props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * @fileOverview spaui 收起展开组件
 * @author kirkzheng
 * @time 2018-07-31
 * @module @tencent/spaui-collapse
 */

/**
 * @class
 */
var Collapse = function (_PureComponent) {
    _inherits(Collapse, _PureComponent);

    function Collapse(props) {
        _classCallCheck(this, Collapse);

        var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

        _this.nullList();

        _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_this);
        return _this;
    }

    _createClass(Collapse, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.init();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.setOpen();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.nullList();
        }
    }, {
        key: 'nullList',
        value: function nullList() {
            this.childrenRef = null;
            this.timeout = null;
        }

        // 展开中的className

    }, {
        key: 'openingClassName',
        value: function openingClassName() {
            var transitionAppear = this.props.transitionAppear;

            (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapse');
            (0, _spauiUtils.removeClassName)(this.childrenRef, 'in');
            if (transitionAppear) {
                (0, _spauiUtils.addClassName)(this.childrenRef, 'collapsing');
            }
        }

        // 展开的className

    }, {
        key: 'openClassName',
        value: function openClassName() {
            (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapsing');
            (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapse');
            (0, _spauiUtils.removeClassName)(this.childrenRef, 'in');
            (0, _spauiUtils.addClassName)(this.childrenRef, 'collapse');
            (0, _spauiUtils.addClassName)(this.childrenRef, 'in');
        }

        // 不展开的className

    }, {
        key: 'unOpenClassName',
        value: function unOpenClassName() {
            (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapsing');
            (0, _spauiUtils.removeClassName)(this.childrenRef, 'collapse');
            (0, _spauiUtils.removeClassName)(this.childrenRef, 'in');
            (0, _spauiUtils.addClassName)(this.childrenRef, 'collapse');
        }

        // 获取内容结构的react信息

    }, {
        key: 'getRect',
        value: function getRect() {
            var result = {
                height: 0
            };

            if (this.childrenRef) {
                this.childrenRef.style.height = 'auto';
                result = this.childrenRef.getBoundingClientRect();
            }

            return result;
        }

        // 初始化展开状态

    }, {
        key: 'init',
        value: function init() {
            var open = this.props.open;

            if (open && this.childrenRef) {
                this.openClassName();
                this.childrenRef.style.height = this.getRect().height + 'px';
                this.childrenRef.style.overflow = '';
            }
        }

        // 根据状态来设置是否展开

    }, {
        key: 'setOpen',
        value: function setOpen() {
            var _this2 = this;

            var open = this.props.open;

            var rect = null,
                dataOpen = '';

            if (this.childrenRef) {
                dataOpen = this.childrenRef.getAttribute('data-open');

                if (!dataOpen || open && dataOpen < 0 || !open && dataOpen > 0) {
                    this.openingClassName();
                    clearTimeout(this.timeout);
                    if (open) {
                        rect = this.getRect();
                        this.childrenRef.style.height = '0px';
                        this.timeout = setTimeout(function () {
                            _this2.childrenRef.style.height = rect.height + 'px';
                            _this2.childrenRef.setAttribute('data-open', 1);
                        }, 4);
                    } else {
                        this.timeout = setTimeout(function () {
                            _this2.childrenRef.style.height = '0px';
                            _this2.childrenRef.setAttribute('data-open', -1);
                        }, 4);
                    }
                }
            }
        }
    }, {
        key: 'handleTransitionEnd',
        value: function handleTransitionEnd() {
            var _props = this.props,
                open = _props.open,
                onTransitionEnd = _props.onTransitionEnd;


            if (this.childrenRef) {
                if (open) {
                    this.openClassName();
                    this.childrenRef.style.overflow = '';
                } else {
                    this.childrenRef.style.overflow = 'hidden';
                    this.unOpenClassName();
                }

                if ((0, _spauiUtils.isFunction)(onTransitionEnd)) {
                    onTransitionEnd(this.childrenRef);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var children = this.props.children;
            var _children$props = children.props,
                props = _children$props === undefined ? {} : _children$props;

            var style = (0, _spauiUtils.objectAssign)(props.style || {}, {
                height: '0px',
                overflow: 'hidden'
            });

            return (0, _react.cloneElement)(children, _extends({}, (0, _spauiUtils.globalProps)(this.props, {
                className: (0, _classnames2.default)('spaui-collapse', 'collapse')
            }, Collapse, this.props), {
                style: style,
                ref: function ref(el) {
                    _this3.childrenRef = el;
                },
                onTransitionEnd: this.handleTransitionEnd
            }));
        }
    }]);

    return Collapse;
}(_react.PureComponent);

// 组件标记与上报


Collapse.propTypes = _props2.propTypes;
Collapse.defaultProps = _props2.defaultProps;
(0, _spauiUtils.setComponentMark)(Collapse, _info3.default, function () {
    (0, _spauiUtils.reportComponentUsage)(_extends({
        scope: 'spaui'
    }, _info3.default));
});

exports.default = Collapse;